import { createSlice } from '@reduxjs/toolkit';
import { ETargetPage, IPage } from '../../types/page';

const initialState: IPage = {
  targetPage: ETargetPage.myHomePage,
};

const pageSlice = createSlice({
  name: 'pageSlice',
  initialState,
  reducers: {
    pageReducer(state) {
      return state;
    },
  },
  extraReducers: {},
});

export const { reducer: pageReducer } = pageSlice;
